import React,
{
  useEffect,
  useState,
  useCallback
} from "react";

import axios from "axios";
import "./OwnerMenu.css";
import { useNavigate } from "react-router-dom";

const BASE_API =
  process.env.BASE_API_URL ||
  "https://scanmymenu-nm38.onrender.com/api";

export default function OwnerMenu() {

  const navigate = useNavigate();

  const restaurantId =
    localStorage.getItem("restaurantId");

  const [restaurant, setRestaurant] =
    useState(null);

  const [items, setItems] =
    useState([]);

  const [name, setName] =
    useState("");

  const [price, setPrice] =
    useState("");

  const [category, setCategory] =
    useState("");

  const [description, setDescription] =
    useState("");

  const [ingredients, setIngredients] =
    useState("");

  const [prepTime, setPrepTime] =
    useState("");

  const [type, setType] =
    useState("Veg");

  const [calories, setCalories] =
    useState("");

  const [image, setImage] =
    useState(null);

  const [model, setModel] =
    useState(null);

  const [loading, setLoading] =
    useState(false);

  const [showForm, setShowForm] =
    useState(false);

  const [search, setSearch] =
    useState("");

  const [
    selectedCategory,
    setSelectedCategory
  ] = useState("All");

  /*
  PLAN STATUS
  */

  const isPlanActive =
    restaurant?.subscriptionStatus === "active";

  const categories = [

    "All",

    ...new Set(
      items.map(
        item =>
          item.category || "Others"
      )
    )

  ];

  /*
  FETCH ITEMS
  */

  const fetchItems =
    useCallback(async () => {

      try {

        /*
        FETCH RESTAURANT
        */

        const restaurantRes =
          await axios.get(
            `${BASE_API}/restaurants/${restaurantId}`
          );

        setRestaurant(
          restaurantRes.data
        );

        /*
        FETCH ITEMS
        */

        const res =
          await axios.get(
            `${BASE_API}/restaurants/${restaurantId}/items`
          );

        const data = res.data;

        if (Array.isArray(data)) {

          setItems(data);

        }
        else if (
          Array.isArray(data.items)
        ) {

          setItems(data.items);

        }
        else {

          setItems([]);

        }

      }
      catch (error) {

        console.error(
          "Fetch items error:",
          error
        );

        setItems([]);

      }

    }, [restaurantId]);

  /*
  LOAD ITEMS
  */

  useEffect(() => {

    fetchItems();

  }, [fetchItems]);

  /*
  ADD ITEM
  */

  const handleSubmit =
    async (e) => {

      e.preventDefault();

      /*
      BLOCK IF PLAN INACTIVE
      */

      if (!isPlanActive) {

        alert(
          "Your subscription is inactive"
        );

        return;

      }

      try {

        setLoading(true);

        const formData =
          new FormData();

        formData.append(
          "name",
          name
        );

        formData.append(
          "price",
          price
        );

        formData.append(
          "category",
          category
        );

        formData.append(
          "description",
          description
        );

        formData.append(
          "ingredients",
          ingredients
        );

        formData.append(
          "prepTime",
          prepTime
        );

        formData.append(
          "type",
          type
        );

        formData.append(
          "calories",
          calories
        );

        if (image)
          formData.append(
            "image",
            image
          );

        if (model)
          formData.append(
            "model",
            model
          );

        await axios.post(
          `${BASE_API}/restaurants/${restaurantId}/items`,
          formData
        );

        setName("");
        setPrice("");
        setCategory("");
        setDescription("");
        setIngredients("");
        setPrepTime("");
        setType("Veg");
        setCalories("");
        setImage(null);
        setModel(null);

        setShowForm(false);

        fetchItems();

      }
      catch (error) {

        alert(
          "Failed to add item"
        );

      }
      finally {

        setLoading(false);

      }

    };

  /*
  DELETE ITEM
  */

  const deleteItem =
    async (itemId) => {

      /*
      BLOCK IF PLAN INACTIVE
      */

      if (!isPlanActive) {

        alert(
          "Your subscription is inactive"
        );

        return;

      }

      try {

        await axios.delete(
          `${BASE_API}/restaurants/${restaurantId}/items/${itemId}`
        );

        fetchItems();

      }
      catch (error) {

        alert("Delete failed");

      }

    };

  /*
  FILTER SEARCH
  */

  const filteredItems =
    items.filter((item) => {

      const matchSearch =
        item.name
          ?.toLowerCase()
          .includes(
            search.toLowerCase()
          );

      const matchCategory =
        selectedCategory === "All"
          ? true
          : item.category ===
            selectedCategory;

      return (
        matchSearch &&
        matchCategory
      );

    });

  /*
  GROUP BY CATEGORY
  */

  const groupedItems =
    filteredItems.reduce(
      (acc, item) => {

        const cat =
          item.category ||
          "Others";

        if (!acc[cat])
          acc[cat] = [];

        acc[cat].push(item);

        return acc;

      },
      {}
    );

  return (

    <div style={styles.container}>

      <div className="hero-section">

        <div>

          <h1>
            Manage Menu
          </h1>

          <p>
            Create, import and manage
            your restaurant food items.
          </p>

        </div>

      </div>

      {/* SEARCH */}

      <div className="search-wrapper">

        <input
          type="text"
          style={{
            width: "100%"
          }}
          placeholder="Search food item..."
          value={search}
          onChange={(e) =>
            setSearch(
              e.target.value
            )
          }
          className="search-input"
        />

      </div>

      {/* CATEGORY BUTTONS */}

      <div className="categories-wrapper">

        {
          categories.map(
            (cat, index) => (

              <button
                key={index}
                className={
                  selectedCategory === cat
                    ? "category-btn active-category"
                    : "category-btn"
                }
                onClick={() =>
                  setSelectedCategory(
                    cat
                  )
                }
              >

                {cat}

              </button>

            )
          )
        }

      </div>

      {/* TOP BUTTONS */}

      <div
        style={{
          display: "flex",
          gap: "12px",
          marginBottom: "0px",
          flexWrap: "wrap"
        }}
      >

        <button
          style={{
            ...styles.createBtn,
            opacity:
              !isPlanActive
                ? 0.5
                : 1,
            cursor:
              !isPlanActive
                ? "not-allowed"
                : "pointer"
          }}
          disabled={
            !isPlanActive
          }
          onClick={() =>
            isPlanActive &&
            setShowForm(
              !showForm
            )
          }
        >

          {
            showForm
              ? "Close Form"
              : "Create New Food Item"
          }

        </button>

        <button
          style={{
            ...styles.createBtn,
            opacity:
              !isPlanActive
                ? 0.5
                : 1,
            cursor:
              !isPlanActive
                ? "not-allowed"
                : "pointer"
          }}
          disabled={
            !isPlanActive
          }
          onClick={() =>
            isPlanActive &&
            navigate(
              "/owner/import-menu"
            )
          }
        >

          Import food items

        </button>

      </div>

      {/* PLAN MESSAGE */}

      {
        !isPlanActive && (

          <p
            style={{
              color: "#dc2626",
              fontSize: "13px",
              fontWeight: "600",
              marginBottom: "18px"
            }}
          >

            Your subscription is inactive.
            Please upgrade your plan.

          </p>

        )
      }

      {/* FORM */}

      {
        showForm && (

          <form
            onSubmit={
              handleSubmit
            }
            style={
              styles.form
            }
          >

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Item Name
              </label>

              <input
                style={
                  styles.input
                }
                placeholder="Enter item name"
                value={name}
                onChange={(e) =>
                  setName(
                    e.target.value
                  )
                }
                required
              />

            </div>

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Price
              </label>

              <input
                type="number"
                style={
                  styles.input
                }
                placeholder="Enter price"
                value={price}
                onChange={(e) =>
                  setPrice(
                    e.target.value
                  )
                }
                required
              />

            </div>

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Type
              </label>

              <select
                value={type}
                style={
                  styles.input
                }
                onChange={(e) =>
                  setType(
                    e.target.value
                  )
                }
              >

                <option value="Veg">
                  Veg
                </option>

                <option value="Non-Veg">
                  Non-Veg
                </option>

                <option value="none">
                  None
                </option>

              </select>

            </div>

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Category
              </label>

              <input
                list="food-categories"
                placeholder="Category"
                style={
                  styles.input
                }
                value={category}
                onChange={(e) =>
                  setCategory(
                    e.target.value
                  )
                }
              />

              <datalist id="food-categories">

                {
                  categories
                    .filter(
                      cat =>
                        cat !==
                        "All"
                    )
                    .map(
                      (
                        cat,
                        index
                      ) => (
                        <option
                          key={
                            index
                          }
                          value={
                            cat
                          }
                        />
                      )
                    )
                }

              </datalist>

            </div>

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Description
              </label>

              <textarea
                style={
                  styles.textarea
                }
                placeholder="Food description"
                value={
                  description
                }
                onChange={(e) =>
                  setDescription(
                    e.target.value
                  )
                }
              />

            </div>

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Items in the Plate
              </label>

              <textarea
                style={
                  styles.textarea
                }
                placeholder="Items in the Plate (Comma separated)"
                value={
                  ingredients
                }
                onChange={(e) =>
                  setIngredients(
                    e.target.value
                  )
                }
              />

            </div>

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Preparation Time
              </label>

              <input
                placeholder="Preparation Time"
                style={
                  styles.input
                }
                value={
                  prepTime
                }
                onChange={(e) =>
                  setPrepTime(
                    e.target.value
                  )
                }
              />

            </div>

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Calories
              </label>

              <input
                type="number"
                placeholder="Calories"
                style={
                  styles.input
                }
                value={
                  calories
                }
                onChange={(e) =>
                  setCalories(
                    e.target.value
                  )
                }
              />

            </div>

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Upload Image
              </label>

              <input
                type="file"
                accept="image/*"
                style={
                  styles.input
                }
                onChange={(e) =>
                  setImage(
                    e.target
                      .files[0]
                  )
                }
              />

            </div>

            <div
              style={
                styles.formGroup
              }
            >

              <label
                style={
                  styles.label
                }
              >
                Upload 3D Model
              </label>

              <input
                type="file"
                accept=".glb,.gltf,.usdz"
                style={
                  styles.input
                }
                onChange={(e) =>
                  setModel(
                    e.target
                      .files[0]
                  )
                }
              />

            </div>

            {
              model && (

                <p>

                  Selected Model:
                  {model.name}

                </p>

              )
            }

            <button
              style={
                styles.submitBtn
              }
              disabled={
                loading
              }
            >

              {
                loading
                  ? "Adding..."
                  : "Add Item"
              }

            </button>

          </form>

        )
      }

      {/* ITEMS */}

      {
        Object.keys(
          groupedItems
        ).length === 0 && (

     <div
  style={{
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    gap: "16px",
  }}
>

  <div
    style={{
      width: "55px",
      height: "55px",
      border: "5px solid #ffe4d1",
      borderTop: "5px solid #ff6b00",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    }}
  />

  <p
    style={{
      margin: 0,
      fontSize: "16px",
      fontWeight: "600",
      color: "#666",
      letterSpacing: "0.3px",
    }}
  >
    Loading food items...
  </p>

  <style>
    {`
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }
    `}
  </style>

</div>

        )
      }

      {
        Object.keys(
          groupedItems
        ).map((cat) => (

          <div key={cat}>

            <h2
              style={
                styles.categoryTitle
              }
            >

              {cat}

            </h2>

            <div
              style={
                styles.list
              }
            >

              {
                groupedItems[
                  cat
                ].map(
                  (
                    item
                  ) => (

                    <div
                      key={
                        item.itemId
                      }
                      className="food-card"
                      onClick={() =>
                        navigate(
                          `/food-item/${item.itemId}`
                        )
                      }
                    >

                      {
                        item.imageUrl && (

                          <img
                            src={
                              item.imageUrl
                            }
                            alt={
                              item.name
                            }
                            // className="food-image2"
                            style={ styles.foodimage2}
                          />

                        )
                      }

                      <div className="food-content" style={{ padding:"5px 4px"}}>

                        <div style={{padding:"0px 10px", }}>

                          <div>

                            <h3 style={{margin: "0px"}}>
                              {item.name}
                            </h3>

                            <p style={{margin: "4px 0px", fontSize:"13px", color:"#555"}}>

                              {
                                item.category
                              }

                            </p>

                          </div>

                          <span className="food-price">

                            ₹{item.price}

                          </span>

                        </div>

                        {/* DESCRIPTION REMOVED */}

                        <div  style={{margin:"8px", display:"flex", gap:"8px"}}>
{/* 
                          <button
                            className="editBtn2"
                            disabled={
                              !isPlanActive
                            }
                            style={{

                              background: "none",
                              color: "#2563eb",
                              border: "1px solid #2563eb",
                              opacity:
                                !isPlanActive
                                  ? 0.5
                                  : 1,
                              cursor:
                                !isPlanActive
                                  ? "not-allowed"
                                  : "pointer"
                            }}
                            onClick={(e) => {

                              e.stopPropagation();

                              if (
                                !isPlanActive
                              )
                                return;

                              navigate(
                                `/edit-item/${item.itemId}`
                              );

                            }}
                          >

                            Edit

                          </button> */}

                          <button
                            className="delete-btn"
                            disabled={
                              !isPlanActive
                            }
                            style={{
                              opacity:
                                !isPlanActive
                                  ? 0.5
                                  : 1,
                              cursor:
                                !isPlanActive
                                  ? "not-allowed"
                                  : "pointer"
                            }}
                            onClick={(e) => {

                              e.stopPropagation();

                              if (
                                !isPlanActive
                              )
                                return;

                              deleteItem(
                                item.itemId
                              );

                            }}
                          >

                            Delete

                          </button>

                        </div>

                      </div>

                    </div>

                  )
                )
              }

            </div>

          </div>

        ))
      }

    </div>

  );

}

const styles = {

  container: {

    padding: "20px",

    minHeight: "100vh",

    background: "#fff7ed",

    fontFamily:
      "Segoe UI, sans-serif",

    width: "100%",

    boxSizing:
      "border-box"

  },

  search: {

    width: "83vw",

    maxWidth: "420px",

    padding: "12px 14px",

    borderRadius: "10px",

    border:
      "1px solid #ddd",

    fontSize: "15px",

    marginBottom: "16px",

    outline: "none",

    transition: "0.3s",

    boxShadow:
      "0 2px 6px rgba(0,0,0,0.05)"

  },

  createBtn: {

    background:
      "linear-gradient(90deg,#ff6a00,#ff8c00)",

    color: "#fff",

    border: "none",

    padding: "12px 18px",

    borderRadius: "10px",

    cursor: "pointer",

    fontWeight: "600",

    fontSize: "14px",

    marginBottom: "22px",

    transition: "0.3s",

    boxShadow:
      "0 4px 12px rgba(255,106,0,0.4)"

  },

  form: {

    background: "#ffffff",

    width: "85%",

    maxWidth: "900px",

    margin:
      "0 auto 24px auto",

    padding: "24px",

    borderRadius: "16px",

    boxShadow:
      "0 8px 20px rgba(0,0,0,0.08)",

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(250px, 1fr))",

    gap: "16px"

  },

  formGroup: {

    display: "flex",

    flexDirection: "column",

    width: "100%"

  },

  input: {

    width: "100%",

    padding: "12px",

    borderRadius: "10px",

    border:
      "1px solid #ddd",

    fontSize: "14px",

    background: "#fafafa",

    outline: "none",

    boxSizing:
      "border-box"

  },

  textarea: {

    width: "100%",

    padding: "12px",

    borderRadius: "10px",

    border:
      "1px solid #ddd",

    fontSize: "14px",

    background: "#fafafa",

    minHeight: "100px",

    resize: "vertical",

    boxSizing:
      "border-box"

  },

  select: {

    width: "100%",

    padding: "12px",

    borderRadius: "10px",

    border:
      "1px solid #ddd",

    background: "#fafafa",

    fontSize: "14px"

  },

  label: {

    fontSize: "14px",

    fontWeight: "600",

    marginBottom: "6px",

    color: "#333"

  },

  submitBtn: {

    gridColumn:
      "1 / -1",

    width: "100%",

    padding: "14px",

    marginTop: "10px",

    background:
      "linear-gradient(90deg,#ff6a00,#ff8c00)",

    color: "#fff",

    border: "none",

    borderRadius: "12px",

    fontSize: "16px",

    fontWeight: "600",

    cursor: "pointer",

    boxShadow:
      "0 4px 12px rgba(255,106,0,0.4)"

  },

  fileInput: {

    padding: "8px"

  },

  categoryTitle: {

    marginTop: "10px",

    marginBottom: "12px",

    paddingBottom: "6px",

    fontSize: "20px",

    fontWeight: "600",

    color: "#ff6a00",

    borderBottom:
      "3px solid #ff6a00"

  },

  /*
  2 ITEMS PER ROW
  */

  list: {

    display: "grid",

    gridTemplateColumns:
      "repeat(2, 1fr)",

    gap: "18px",

    width: "100%"

  },

  editBtn2: {

    background:
      "linear-gradient(90deg,#2563eb,#1d4ed8)",

    color: "#fff",

    border: "none",

    padding: "0px 10px",

    borderRadius: "8px",

    cursor: "pointer",

    fontWeight: "600",

    height: "32px"

  },

  card: {

    display: "flex",

    justifyContent:
      "space-between",

    alignItems: "center",

    background: "#ffffff",

    padding: "5px 14px",

    borderRadius: "14px",

    boxShadow:
      "0 6px 14px rgba(0,0,0,0.08)",

    transition: "0.3s",

    cursor: "pointer"

  },

  image: {

    width: "100%",

    height: "170px",

    objectFit: "cover",

    borderRadius: "10px",

    marginBottom: "10px"

  },

  deleteBtn: {

    background:
      "linear-gradient(90deg,#ff4d4d,#ff0000)",

    color: "#fff",

    border: "none",

    padding: "9px",

    borderRadius: "8px",

    cursor: "pointer",

    marginTop: "10px",

    fontWeight: "600"

  },

  foodimage2: {
    width: "100%",
    height: "150px",
  }
};